import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {Price} from '../types';

export const RecordForm = ({
                               record,
                               handleSubmit,
                               handleCancel,
                           }: {
    record: Omit<Price, 'id'>,
    handleSubmit: (values: Price) => void,
    handleCancel?: () => void
}) => {

    // FNP-918 (§6): `onSubmit` is ASYNC and RETURNS the mutation promise.
    //
    // It previously called `handleSubmit(values)` and dropped the promise on the
    // floor. Formik then cleared `isSubmitting` on the same tick, so the shared
    // button's `disabled={isSubmitting}` never engaged and double-submit was
    // live. On a PRICE that matters more than most: a double-submitted create
    // is two prices on the same product.
    //
    // It also breaks the drawer above it: FormDrawer does `await
    // handleSubmit(values); onClose();`, which is the CORRECT shape, but
    // awaiting a dropped promise resolves immediately — so a server-side
    // rejection still closed the drawer and destroyed the operator's input.
    const onSubmit = async (values: Price) => {
        await handleSubmit(values);
    };

    const onCancel = () => {
        handleCancel?.();
    };


    let initialValues = {
        currency: 'usd',
        billingScheme: 'perUnit'
    } as Price;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false} {...rest}  >
                    <FormComponent handleSubmit={handleSubmit} isSubmitting={isSubmitting} {...rest}/>
                </FormWithButtons>)}
        </Formik>
    );
};
